<template>
  <div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Name</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="agent.username" class="input oc-input" type="text" />
          </p>
          <p class="help is-danger" v-if="!$v.agent.username.required">Name is required</p>
          <p class="help is-danger" v-if="!$v.agent.username.minLength || !$v.agent.username.maxLength">Name length 3-50</p>
          <p class="help is-danger" v-if="!$v.agent.username.isUnique">User with the same name already exists</p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Password</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="agent.password" class="input oc-input" type="text" />
          </p>
          <p class="help is-danger" v-if="!$v.agent.password.required">Password is required</p>
          <p class="help is-danger" v-if="!$v.agent.password.minLength || !$v.agent.password.maxLength">Password length 4-50</p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Phone</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="agent.phoneNumber" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Email</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="agent.email" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Language</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <div class="select">
              <select v-model="agent.language">
                <option v-for="lang in languages" :key="lang">{{lang}}</option>
              </select>
            </div>
          </div>
          <p class="help is-danger" v-if="!$v.agent.language.required">Language is required</p>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button class="button is-primary" @click="create()" :disabled="$v.$invalid">Create</button>
      </div>
    </div>
  </div>
</template>
<script>
  import state from '../../../../../state'
  import agentService from '../../../../../services/agent.service'
  import { required, minLength, maxLength } from 'vuelidate/lib/validators'

  export default {
    name: 'agent-create',
    data() {
      return {
        agent: {
          username: '',
          phoneNumber: '',
          email: '',
          password: '',
          language: null
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      },
      client() {
        return state.clients.getClient(this.clientId)
      },
      registrationTypes() {
        return this.client.settings.registrationSettings.registrationTypes;
      },
      languages() {
        return state.languages.get();
      }
    },
    validations: {
      agent: {
        username: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(50),
          async isUnique(value) {
            return !value || (await agentService.checkUsername(value, this.clientId)).isValid;
          }
        },
        password: {
          required,
          minLength: minLength(4),
          maxLength: maxLength(50)
        },
        language: {
          required
        }
      }
    },
    methods: {
      async create() {
        this.agent.clientId = this.clientId;
        await agentService.create(this.agent);
        this.$router.push({ name:'agents' });
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/agents/agent/create.vue